import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';

export const Banner = ({ className, content, to }: BannerProps) => {
  const linkProps = useMemo(() => {
    if (to) {
      return {
        component: 'a' as const,
        href: to,
        target: '_blank',
      };
    }
    return {};
  }, []);
  return (
    <Box
      className={className}
      {...linkProps}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none',
        gap: sp[8],
        background: '#003413',
        p: sp[12],
        color: '#ffffff',
        typography: 'bodyMd',
        '& > div': { textAlign: 'center' },
      }}
    >
      {content}
    </Box>
  );
};

interface BannerProps {
  className?: string;
  content: React.ReactNode;
  to?: string;
}

Banner.displayName = 'Banner';

export default Banner;
